<div class="statistics-page">

  <div class="statistics-page__header">
    <div class="statistics-page__title">
      <h1>{{ 'statistics.page.title' | transloco }}</h1>
      @if (response) {
        <p class="statistics-page__subtitle">
          {{ 'statistics.page.subtitle' | transloco }} · {{ 'statistics.page.period' | transloco }} {{ periodLabel }}
        </p>
      }
    </div>

    <div class="statistics-page__controls">
      <p-select
        [options]="animalShelterOptions"
        [ngModel]="selectedShelterId"
        optionLabel="label"
        optionValue="value"
        [disabled]="loading"
        (onChange)="onShelterChange($event.value)">
      </p-select>

      @if (years.length) {
        <div class="statistics-page__years">
          <button
            type="button"
            class="statistics-page__year-step"
            [disabled]="!canPageBack || loading"
            [attr.aria-label]="'statistics.filter.earlierYears' | transloco"
            (click)="pageYears(-1)">
            <i class="pi pi-chevron-left"></i>
          </button>

          @for (year of visibleYears; track year) {
            <button
              type="button"
              class="statistics-page__year"
              [class.statistics-page__year--active]="year === selectedYear"
              [disabled]="loading"
              [pTooltip]="isRunningYear(year) ? ('statistics.filter.runningYearHint' | transloco) : ''"
              (click)="onYearChange(year)">
              {{ year }}@if (isRunningYear(year)) {<span class="statistics-page__year-running">·</span>}
            </button>
          }

          <button
            type="button"
            class="statistics-page__year-step"
            [disabled]="!canPageForward || loading"
            [attr.aria-label]="'statistics.filter.laterYears' | transloco"
            (click)="pageYears(1)">
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      }

      <p-button
        icon="pi pi-print"
        severity="secondary"
        [outlined]="true"
        [disabled]="loading || !response"
        [label]="'statistics.page.print' | transloco"
        (onClick)="print()">
      </p-button>
    </div>
  </div>

  <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)">
    <p-tablist>
      <p-tab value="overview">{{ 'statistics.page.tabOverview' | transloco }}</p-tab>
      <p-tab value="report">{{ 'statistics.page.tabReport' | transloco }}</p-tab>
    </p-tablist>

    <p-tabpanels>
      <p-tabpanel value="overview">

        @if (loading) {
          <div class="statistics-page__loading">
            <p-progressSpinner styleClass="statistics-page__spinner" strokeWidth="4"></p-progressSpinner>
            <span>{{ 'statistics.page.loading' | transloco: {year: selectedYear} }}</span>
          </div>
          <div class="statistics-page__skeletons">
            <div class="statistics-page__skeleton-row">
              <p-skeleton height="9rem"></p-skeleton>
              <p-skeleton height="9rem"></p-skeleton>
              <p-skeleton height="9rem"></p-skeleton>
            </div>
            @for (line of skeletonLines; track line) {
              <p-skeleton height="2.75rem"></p-skeleton>
            }
          </div>
        } @else if (loadFailed) {
          <p-message severity="error" [text]="'statistics.page.loadFailed' | transloco"></p-message>
        } @else if (response) {

          @if (isCurrentYear) {
            <p-message severity="info" styleClass="statistics-page__notice">
              <span>
                <strong>{{ 'statistics.page.currentYearTitle' | transloco: {date: periodEndLabel} }}</strong>
                {{ 'statistics.page.currentYearHint' | transloco }}
              </span>
            </p-message>
          }

          @if (isEmptyYear) {
            <div class="statistics-page__empty">
              <i class="pi pi-chart-bar"></i>
              <h2>{{ 'statistics.page.emptyTitle' | transloco: {year: selectedYear} }}</h2>
              <p>{{ 'statistics.page.emptyHint' | transloco }}</p>
            </div>
          } @else {
            <app-statistics-overview
              [response]="response"
              [previousResponse]="previousResponse"
              [rows]="rows"
              [trend]="trend"
              [trendLoading]="trendLoading"
              [startLabel]="startLabel"
              [endLabel]="endLabel"
              [(sortBySize)]="sortBySize"
              [(hideEmptyCategories)]="hideEmptyCategories"
              [(compareWithPreviousYear)]="compareWithPreviousYear"
              (yearSelect)="onYearChange($event)">
            </app-statistics-overview>
          }
        }
      </p-tabpanel>

      <p-tabpanel value="report">
        @if (loading) {
          <div class="statistics-page__loading">
            <p-progressSpinner styleClass="statistics-page__spinner" strokeWidth="4"></p-progressSpinner>
            <span>{{ 'statistics.page.loading' | transloco: {year: selectedYear} }}</span>
          </div>
        } @else if (response) {
          <app-statistics-report
            [response]="response"
            [rows]="rows"
            [startLabel]="startLabel"
            [endLabel]="endLabel"
            [shelterLabel]="shelterLabel">
          </app-statistics-report>
        }
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
